<template>
  <div class="t-success">
    <svg width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="49.5" cy="49.5" r="49.5" fill="#33BD82" />
      <path d="M26 50.7805L41.1488 66L73 34" stroke="white" stroke-width="5" stroke-linejoin="round" />
    </svg>
    <h3 class="t-success__title">{{ props.title }}</h3>
    <div class="t-success__text">{{ props.text }}</div>
    <div class="t-success__row">
      <a class="t-btn _back t-success__btn _events" href="/documents/certificateAMP" target="_blank">
        Скачать сертификат 1
      </a>
      <div class="t-btn _back t-success__btn _events" @click="downSert">
        Скачать сертификат 2
      </div>
      <div class="t-btn _back t-success__btn _events" @click="downSert2">
        Скачать сертификат 3
      </div>
      <span @click="$emit('form:clear')" class="t-btn _back t-success__btn _events">
        Пройти повторно
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from "vuex"

export default {
  props: ["props"],
  computed: {
    ...mapGetters('questionnaries', ['username', 'companyName']),
  },
  methods: {
    async downSert() {
      const response = await Vue.http.get(`/api/events/getAmpCert/${this.username}/${this.companyName}`)
      console.log('downSert', response)
    },
    async downSert2() {
      const response = await Vue.http.get(`/events/ampCert/${this.username}/${this.companyName}`)
      console.log('downSert', response)
    }
  }
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/components/success.vue